<template>
  <transition name="fade" mode="out-in">
    <div v-if="isActive">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'tabPage',
  data () {
    return {
      isActive: false
    }
  },
  props: {
    label: String,
    name: String,
    currentTab: String
  },
  watch: {
    isActive (newValue) {
      if (newValue) this.$parent.$emit('tab-changed', this.$props.name)
    }
  }
}
</script>
